export enum PlanCategoryType {
  Whitegoods = 'W',
  Heating = 'H',
}
